import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { EmpresaListarComponent } from './empresa-listar.component';
import { EmpresaListarRoutingModule } from './empresa-listar-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from "primeng/tooltip";
import { DividerModule } from 'primeng/divider';
import { FormatPipeModule } from 'src/app/admihair/format-pipe/format-pipe.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';


@NgModule({
 
  imports: [
    CommonModule,    
    TableModule,
    HttpClientModule,
    EmpresaListarRoutingModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DividerModule,
    FormatPipeModule,
    ProgressSpinnerModule,
    MessagesModule
  ],
  declarations: [
    EmpresaListarComponent
  ],
  exports: [
    EmpresaListarComponent
  ]
})
export class EmpresaListarModule { }
